module.exports = __webpack_public_path__ + "static/img/no_permission.bf5885f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/no_permission.png
// module id = SGdG
// module chunks = 0